// removed by extract-text-webpack-plugin
module.exports = {"content":"PatientProfileCreate__content__3ZbGU","registryFormWrapper":"PatientProfileCreate__registryFormWrapper__L6qpY","randomizeFormWrapper":"PatientProfileCreate__randomizeFormWrapper__2e0KO","parentContainer":"PatientProfileCreate__parentContainer__2HN57","searchWrapper":"PatientProfileCreate__searchWrapper__InvzK","searchWrapperLabel":"PatientProfileCreate__searchWrapperLabel__1zE1x","toggleHeadline":"PatientProfileCreate__toggleHeadline__1Q-Rz","collapseIcon":"PatientProfileCreate__collapseIcon__2gyIv","toggleText":"PatientProfileCreate__toggleText__2J3yR"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PatientProfileCreate/PatientProfileCreate.css
// module id = 2855
// module chunks = 0